<template>
  <div class="test-wrapper">
    <p class="step">Шаг 2</p>
    <h2 class="step_name">Заполните форму</h2>

    <div
      class="text"
    >Остался один шаг до тестирования - заполнение формы. Это займет не более 2 минут
    </div>

    <form id="tests" @submit.prevent="checkForm">
      <input type="hidden" name="quiz-device-type" v-model="quizDeviceType">
      <input type="hidden" name="quiz-device-os" v-model="quizDeviceOs">
      <div class="input-wrapper">
        <div class="form-input">
          <label>
            <span class="req">
              <b>Имя</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <input name="name" value type="text" v-model="name" @change="checkErrors">
            <template v-if="errors.length">
              <div v-for="error in errors">
                <p class="error-msg" v-if="error.key === 'name'">{{ error.message }}</p>
              </div>
            </template>
          </label>
        </div>

        <div class="form-input">
          <label>
            <span class="req">
              <b>Фамилия</b>
            </span>
            <input name="lastname" value type="text" v-model="lastname">
          </label>
        </div>

        <div class="form-input">
          <label>
            <span class="req">
              <b>Email:</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <input name="email" value type="text" v-model="email" @change="checkErrors">
            <template v-if="errors.length">
              <div v-for="error in errors">
                <p class="error-msg" v-if="error.key === 'email'">{{ error.message }}</p>
              </div>
            </template>
          </label>
        </div>

        <div class="form-input">
          <label>
            <span class="req">
              <b>Телефон:</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <input
              ref="phone"
              name="phone"
              value
              class="js-inputmask-custom phone valid ignore-validate"
              type="tel"
              v-model="phone"
              @input="checkErrors"
            >
            <template v-if="errors.length">
              <div v-for="error in errors">
                <p class="error-msg" v-if="error.key === 'phone'">{{ error.message }}</p>
              </div>
            </template>
          </label>
        </div>

        <div
          class="form-input"
          v-if="
            Number(this.$route.params.langId) === 674 && Number(this.$route.params.catId) === 722
          "
        >
          <label>
            <span class="req">
              <b>Компания:</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <input name="company" value class="required" type="text" v-model="company" @input="checkErrors">
          </label>
        </div>

        <div class="form-input" v-if="Number(this.$route.params.langId) === 674 && Number(this.$route.params.catId) !== 722">
          <label>
            <span class="req">
              <b>Форма обучения:</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <select class="place lessons" data-placeholder="Формат обучения" v-model="formLessons">
              <option v-for="formItem in formLessonslist" :value="formItem">{{ formItem }}</option>
            </select>
          </label>
        </div>
        <div class="form-input school"
             v-if="formLessons === 'В школе' && Number(this.$route.params.langId) === 674 && Number(this.$route.params.catId) !== 722">
          <label>
           <span class="req">
              <b>Выберите школу</b>
              <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
            </span>
            <select class="place schools" v-model="school" data-placeholder="Выберите школу">
              <option v-for="schoolItem in schoolList" :value="schoolItem.id">{{ schoolItem.name }}</option>
            </select>
            <template v-if="errors.length">
              <div v-for="error in errors">
                <p class="error-msg" v-if="error.key === 'school'">{{ error.message }}</p>
              </div>
            </template>
          </label>
        </div>

        <div class="form-input" v-if="Number(this.$route.params.langId) !== 674">
          <span class="req">
            <b>Формат занятий</b>
            <span class="necessarily">ОБЯЗАТЕЛЬНО</span>
          </span>
          <div class="form-field">
            <div class="form-input-ratio">
              <input id="format3" type="radio" name="format" value="В школе" class="radio-btn-input" checked>
              <label for="format3">В школе</label>
            </div>
            <div class="form-input-ratio">
              <input id="format4" type="radio" name="format" value="Онлайн" class="radio-btn-input">
              <label for="format4">Онлайн</label>
            </div>
          </div>
        </div>

        <div class="rules_confirm">
          <input class="check_rules" type="checkbox" v-model="isConfirm" @change="checkErrors">
          <label class="text_rules">
            Я даю согласие на обработку моих персональных данных  У ДО "Лингвист" (ИНН 7709443573) в целях обработки заявки и обратной связи. Политика конфиденциальности — по
            <a
              href="/agreement/"
              class="link_rules"
            >ссылке</a>.
          </label>
          <template v-if="errors.length">
            <div v-for="error in errors">
              <p class="error-msg" v-if="error.key === 'confirm'">{{ error.message }}</p>
            </div>
          </template>
        </div>
      </div>

      <div class="button-wrapper">
        <div class="test-next">
          <div class="form-submit">
            <input type="submit" id="form_test" value="Приступить" :disabled="isSending">
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import Inputmask from 'inputmask';
import device from "current-device";

export default {
  name: 'StepTwo',
  data() {
    return {
      schoolList: [],
      errors: [],
      isSending: true,
      name: null,
      lastname: null,
      email: null,
      phone: null,
      company: '',
      isConfirm: false,
      formLessons: '',
      formLessonslist: [
        'В школе',
        'Онлайн',
      ],
      // school: null,
      school: 'Выберите школу',
      quizDeviceType: device.type,
      quizDeviceOs: device.os,
    }
  },

  mounted: function () {
    this.scrollToTest()
    if (Number(this.$route.params.langId) === 674
    && Number(this.$route.params.catId) !== 722) {
      this.getSchools()
    }
    this.$nextTick(() => {
      $('.lessons').select2({
        // placeholder: "Select a state",
        // minimumResultsForSearch: Infinity
      })
      $('.place').select2({
        minimumResultsForSearch: Infinity
      })
      $('.schools').select2({
        placeholder: "Select a state",
        minimumResultsForSearch: Infinity
      }).on('change', event => {
        this.school = event.target.value
        this.checkErrors();
      });
      $('.lessons').on('change', event => {
        this.formLessons = event.target.value
        if (this.formLessons === 'Онлайн') {
          this.school = false
        } else {
          // this.school = this.schoolList[0].id
        }
        this.$nextTick(() => {
          $('.schools').select2({
            placeholder: "Select a state",
            minimumResultsForSearch: Infinity
          }).on('change', event => {
            this.school = event.target.value
            this.checkErrors();
          });
        })
      })

      $(this.$el).find('.js-inputmask-custom').each((index, el) => {
        Inputmask({
          regex: "\\+7-[0-7,9]\\d\\d-\\d\\d\\d-\\d\\d-\\d\\d",
          onBeforeWrite: function (value, opts) {
            return value;
          }
        }).mask(el);
      });
    })
  },
  methods: {
    scrollToTest: function () {
      $('html, body').animate(
        {scrollTop: $('.container-test').offset().top},
        0
      )
    },
    getSchools: function () {
      axios.get(`/quiz/api/language.php?allschools=true`).then(response => {
        let schoolFilterArr = response.data.filter(schoolItem => ((schoolItem.id !== '1123004') || !(schoolItem.name.startsWith('Корпоративный')) )); // id школы "Корпоративный отдел"
        schoolFilterArr = schoolFilterArr.sort(this.sortSchool);
        let schoolSortArrMBA = schoolFilterArr.filter(schoolItem => ((schoolItem.id === '100') || (schoolItem.name.startsWith('MBA Centre')) ));  // id школы "MBA Centre IELTS, TOEFL, GMAT, GRE"
        let schoolSortArrBKC = schoolFilterArr.filter(schoolItem => ((schoolItem.id !== '100') || !(schoolItem.name.startsWith('MBA Centre')) ));
        schoolSortArrBKC.push(...schoolSortArrMBA);
        // this.schoolList = response.data
        this.schoolList = schoolSortArrBKC;
        // this.school = this.schoolList[0].id
      }).catch(error => {
        alert(error.response.errors)
      })

      return true
    },
    sortSchool: function(x, y) {
      if (x.name < y.name) {return -1;}
      if (x.name > y.name) {return 1;}
      return 0;
    },
    checkErrors() {
      this.errors = [];
      let isError = false;

      if (Number(this.$route.params.langId) === 674) {
        this.formLessons = $('.place').val()
      } else {
        this.formLessons = $('input[name="format"]:checked').val()
      }

      if (!this.name) {
        isError = true;
        this.errors.push({
          key: 'name',
          message: 'Заполните поле имя'
        })
      }
      if (!this.email) {
        isError = true;
        this.errors.push({
          key: 'email',
          message: 'Заполните поле email'
        });
      }
      if (this.email && !this.validEmail(this.email)) {
        isError = true;
        this.errors.push({
          key: 'email',
          message: 'Email имеет неверный формат'
        });
      }
      if (this.formLessons != 'Онлайн'
        && !this.school
        && Number(this.$route.params.langId) === 674
        && Number(this.$route.params.catId) !== 722) {
          isError = true;
          this.errors.push({
            key: 'school',
            message: 'Заполните поле выбора школы'
          })
      }

      if (!this.phone) {
        isError = true;
        this.errors.push({
          key: 'phone',
          message: 'Заполните поле телефона'
        })
      }

      if (this.phone && !this.$refs.phone.inputmask.isComplete()) {
        isError = true;
        this.errors.push({
          key: 'phone',
          message: 'Неверный формат телефона'
        })
      }

      if (
        Number(this.$route.params.langId) === 674 &&
        Number(this.$route.params.catId) === 722
      ) {
        if (!this.company) {
          isError = true
          this.errors.push({
            key: 'company',
            message: 'Заполните поле выбора компании'
          })
        }
      }
      if (!this.isConfirm) {
        isError = true;
        this.errors.push({
          key: 'confirm',
          message: 'Подтвердите согласие на обработку данных'
        });
      }
      return isError;
    },
    checkForm: function (e) {
      if (!this.isSending) return;

      if (this.checkErrors()) return false;

      this.isSending = true;

      let url = '/quiz/api/test.php?create'

      $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: {
          lang_id: this.$route.params.langId,
          cat_id: this.$route.params.catId,
          school: this.school,
          formLessons: this.formLessons,
          device_type: this.quizDeviceType,
          device_os: this.quizDeviceOs,
          user: {
            name: this.name,
            lastname: this.lastname,
            email: this.email,
            phone: this.phone,
            company: this.company,
          }
        },
        success: data => {
          if (data) {
            if (
              Number(this.$route.params.langId) === 674 &&
              data[0]['theme_block'] === '1'
            ) {
              this.$router.push(`/test-adult`)
            } else {
              this.$router.push(`/test`)
            }
          }
          this.isSending = false;
        },
        error: () => {
          alert('Ошибка!');
          this.isSending = false;
        }
      })
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // var re = /[^0-9A-Za-z\@\.]/g;
      return re.test(email)
    }
  }
}
</script>

<style scoped lang="sass">
.buttons_lvl
  div.active
    background: #6ed9de
    color: #fff

.error-msg
  color: red
  font-size: 16px
  margin: 12px 0

.form-input .form-field
  display: flex
  gap: 20px

.form-input .radio-btn-input + label::before
  border-color: #093589

.form-input .radio-btn-input + label::after
  background: #093589
</style>



// WEBPACK FOOTER //
// src/components/StepTwo.vue